module.exports = __webpack_public_path__ + "img/img0.8ba8d7a4.png";